<template>
    <div>
        <label v-if="label">{{label}}</label>
        <div class="input-group mb-3">
            <div class="form-group-feedback form-group-feedback-left">
                <input type="text" class="form-control alpha-grey" :placeholder="placeholder" :value="value" ref="inputSearch" @input="change" @keyup.enter="search">
                <div class="form-control-feedback form-control-feedback-lg">
                    <i class="icon-search4 text-muted"/>
                </div>
            </div>
            <div class="input-group-append cursor-pointer" @click="resetInput">
                <i v-if="!buttonDisabled" class="icon-cross2 text-muted clear-icon"/>
                <i v-else class="icon-cross2 text-muted clear-icon" style="right: 0"/>
            </div>
            <div v-if="!buttonDisabled" class="input-group-append">
                <button type="submit" class="btn btn-ums" @click="search">Search</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InputSearch",
        props: {
            buttonDisabled: {
              type: Boolean,
              default: false
            },
            label: {
                type:String
            },
            value: {
                type: String
            },
            placeholder: {
                type: String,
                default: 'Search'
            }
        },
        methods: {
            change:function(e) {
                this.$emit('input',this.$refs.inputSearch.value)
            },
            search:function() {
                this.$emit('search')
            },
            resetInput: function() {
                this.$refs.inputSearch.value = ''
                this.$emit('input',this.$refs.inputSearch.value)
            }
        },
    }
</script>

<style scoped>
    .clear-icon {
        position: absolute;
        top: -1px;
        color: #333;
        padding-left: .875rem;
        padding-right: .875rem;
        line-height: calc(1.5385em + .875rem + 2px);
        min-width: 1rem;
        right: 67px;
        z-index: 300;
    }
</style>
